function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
window.MIL_Reactions = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }
  _createClass(_class, [{
    key: "init",
    value: function init(container, options) {
      var defaults = {
        reactions: {
          love_burst: {
            quantity: 1,
            // quanti elementi per reaction
            duration: 2000,
            // durata reaction in ms
            speed: 50,
            // intervallo fra elementi della reaction
            delay_close: 3000 // porta canvas in 2° piano
          }
        }
      };

      this.$container = $(container);
      this.options = Object.assign({}, defaults, options);
      this.is_reacting = false;
      console.log('MIL_Reactions', this);
    }
  }, {
    key: "reaction",
    value: function reaction(callback, options) {
      if (!this[callback]) {
        console.log(callback + ' invalid reaction');
        return false;
      }
      return this[callback](options);
    }
  }, {
    key: "love_burst",
    value: function love_burst(options) {
      if (this.is_reacting) return false;
      var speed = this.options.reactions.love_burst.speed;
      var duration = this.options.reactions.love_burst.duration;
      var delay_close = this.options.reactions.love_burst.delay_close;
      this.start_burst_reaction();
      var reaction_started_at = new Date().getTime();
      var burst_interval = setInterval(function () {
        if (new Date().getTime() - reaction_started_at > duration) {
          clearInterval(burst_interval);
          setTimeout(function () {
            MIL_Reactions.stop_burst_reaction();
          }, delay_close);
          return;
        }
        MIL_Reactions.love(options);
      }, this.options.reactions.love_burst.speed);
      return true;
    }
  }, {
    key: "start_burst_reaction",
    value: function start_burst_reaction() {
      this.is_reacting = true;
      this.$container.css('z-index', 999999);
    }
  }, {
    key: "stop_burst_reaction",
    value: function stop_burst_reaction() {
      this.$container.css('z-index', -1);
      this.is_reacting = false;
    }
  }, {
    key: "love",
    value: function love(options) {
      //console.log('love you!!!!', options);

      var r_num, r_size, r_left, r_bg, r_time, r_red, i;
      var quantity = this.options.reactions.love_burst.quantity;
      for (i = 0; i < quantity; i++) {
        r_num = Math.floor(Math.random() * 40) + 1;
        r_size = Math.floor(Math.random() * 65) + 10;
        r_left = Math.floor(Math.random() * 100) + 1;
        r_bg = Math.floor(Math.random() * 25) + 100;
        r_time = Math.floor(Math.random() * 5) + 5;
        r_red = 255;
        this.$container.append("<div class='heart' style='width:" + r_size + "px;height:" + r_size + "px;left:" + r_left + "%;background:rgba(" + r_red + "," + (r_bg - 25) + "," + r_bg + ",1);-webkit-animation:love " + r_time + "s ease;-moz-animation:love " + r_time + "s ease;-ms-animation:love " + r_time + "s ease;animation:love " + r_time + "s ease'></div>");
      }

      //$canvas.append("<div class='heart' style='width:" + (r_size - 10) + "px;height:" + (r_size - 10) + "px;left:" + (r_left + r_num) + "%;background:rgba(255," + (r_bg - 25) + "," + (r_bg + 25) + ",1);-webkit-animation:love " + (r_time + 5) + "s ease;-moz-animation:love " + (r_time + 5) + "s ease;-ms-animation:love " + (r_time + 5) + "s ease;animation:love " + (r_time + 5) + "s ease'></div>");

      $('.heart').each(function () {
        var top = $(this).css("top").replace(/[^-\d\.]/g, '');
        var width = $(this).css("width").replace(/[^-\d\.]/g, '');
        if (top <= -100 || width >= 150) {
          $(this).detach();
        }
      });
      return true;
    }
  }]);
  return _class;
}())();